import { useState, useEffect } from "react";
import { SortDirection, SortItem } from "./types";

export const useSortGroupState = (
  fieldName: string,
  sortList: SortItem[],
  setSortList: (list: SortItem[]) => void,
) => {
  const existingSort = sortList?.find((sort) => sort.field === fieldName);
  const [selectedDirection, setSelectedDirection] =
    useState<SortDirection | null>(existingSort?.direction || null);

  const handleChange = (newDirection: SortDirection | null) => {
    setSelectedDirection(newDirection);

    if (newDirection) {
      const existingIndex = sortList?.findIndex(
        (sort) => sort.field === fieldName,
      );

      if (existingIndex !== -1) {
        const newSortList = [...sortList];
        newSortList[existingIndex] = {
          field: fieldName,
          direction: newDirection,
        };
        setSortList(newSortList);
      } else {
        setSortList([
          ...sortList,
          { field: fieldName, direction: newDirection },
        ]);
      }
    } else {
      setSortList(sortList?.filter((sort) => sort.field !== fieldName));
    }
  };

  const handleRemove = () => {
    setSortList(sortList?.filter((sort) => sort.field !== fieldName));
  };

  useEffect(() => {
    const existingSort = sortList?.find((sort) => sort.field === fieldName);
    setSelectedDirection(existingSort?.direction || null);
  }, [sortList, fieldName]);

  return { selectedDirection, handleChange, handleRemove };
};
